"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProbabilityOutcomeNameV2 = void 0;
const getProbabilityOutcomeNameV2 = ({ competitors, isShortNamed, }) => {
    const { homeCompetitors, awayCompetitors } = competitors;
    const homeCompetitorNames = homeCompetitors.map((c) => c.name).join(', ');
    const awayCompetitorNames = awayCompetitors.map((c) => c.name).join(', ');
    return (outcomeTypeData) => {
        const name = isShortNamed ? outcomeTypeData.shortName : outcomeTypeData.name;
        return name
            .replaceAll('{$competitor1}', homeCompetitorNames)
            .replaceAll('{$competitor2}', awayCompetitorNames);
    };
};
exports.getProbabilityOutcomeNameV2 = getProbabilityOutcomeNameV2;
//# sourceMappingURL=getProbabilityOutcomeNameV2.js.map